module.exports = "/_next/static/images/expert-efren-hernandez-41129225adda64194e53c9f3c8358c4c.png";